import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tracking-layout',
  templateUrl: './tracking-layout.component.html',
  styleUrls: ['./tracking-layout.component.css']
})
export class TrackingLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
